/*
 * サブシステム名：
 * 機能名：実運送体制管理簿
 */
import flowMixin from '@/mixins/flowMixins'
import date from '@/ddv2.library/date'
// import validators from '@/rahmen/validators'
import modals from '@/ddv2.library/modals'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import DdCustomButton from '@/components/DdCustomButton'
import DdJitsuUnsoTaiseiKanriboSpread from '@/components/DdJitsuUnsoTaiseiKanriboSpread'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdDateRangeBox from '@/components/DdDateRangeBox'
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
export default {
  name: 'JitsuUnsoTaiseiKanriListEdit',
  mixins: [flowMixin],
  data: () => ({
    isConditionHide: false,
    conditions: {},
    conditionDetails: [
      { key: 'tsumikomiYmdFromTo', name: '積込日', value: 'tsumikomiYmdFromTo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'maninushiNm', name: '真荷主名', value: 'maninushiNm', type: 'value', delete: true, showValue: true, convertValue: false }
    ],
    rec: {
      jitsuUnsoTaiseiKanriList: [],
      dispJitsuUnsoTaiseiKanriList: []
    },
    modeKengen: 0
  }),
  components: {
    DdCustomButton,
    DdDateRangeBox,
    DdDefaultButton,
    DdFooterButton,
    DdJitsuUnsoTaiseiKanriboSpread,
    DdSubHeader,
    DdTextBox,
    DdTransparentButton
  },
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 積込日
    'conditions.tsumikomiStartYmdString': function (n) {
      var tsumikomiYmdFromTo = ![undefined, null, ''].includes(this.conditions.tsumikomiStartYmdString) ? this.conditions.tsumikomiStartYmdString.slice(-5) : ''
      tsumikomiYmdFromTo = tsumikomiYmdFromTo + (![undefined, null, ''].includes(this.conditions.tsumikomiEndYmdString) ? '～' + this.conditions.tsumikomiEndYmdString.slice(-5) : '')
      this.conditions.tsumikomiYmdFromTo = tsumikomiYmdFromTo
    },
    'conditions.tsumikomiEndYmdString': function (n) {
      var tsumikomiYmdFromTo = ![undefined, null, ''].includes(this.conditions.tsumikomiStartYmdString) ? this.conditions.tsumikomiStartYmdString.slice(-5) : ''
      tsumikomiYmdFromTo = tsumikomiYmdFromTo + (![undefined, null, ''].includes(this.conditions.tsumikomiEndYmdString) ? '～' + this.conditions.tsumikomiEndYmdString.slice(-5) : '')
      this.conditions.tsumikomiYmdFromTo = tsumikomiYmdFromTo
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle'
    }),
    createButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    isOutputButtonDisabled () {
      return this.rec.jitsuUnsoTaiseiKanriList.length === 0
    },
    rowCount () {
      return this.rec.dispJitsuUnsoTaiseiKanriList.length || 0
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
              self.onRowAddClick(3)
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/TrJitsuUnsoTaiseiKanribo/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.isConditionHide = true

          const res = data.payload

          res.map((elem) => {
            elem.tsumikomiYmd = elem.tsumikomiYmd ? filter.dateFormatter(elem.tsumikomiYmd) : ''
            return elem
          })
          self.rec.jitsuUnsoTaiseiKanriList = Object.assign([], res) || []
          self.rec.dispJitsuUnsoTaiseiKanriList = Object.assign([], res) || []

          const cache = {
            conditions: self.conditions
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    onSaveButtonClick: function (e) {
      console.log('save', this)
      const self = this
      if (!self.rec.dispJitsuUnsoTaiseiKanriList || self.rec.dispJitsuUnsoTaiseiKanriList.length < 1) { return }
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            if (data.isValid) {
              const res = data.payload
              const tmpDispJitsuUnsoTaiseiKanriList = Object.assign([], self.rec.dispJitsuUnsoTaiseiKanriList)

              res.map((elem) => {
                elem.tsumikomiYmd = elem.tsumikomiYmd ? filter.dateFormatter(elem.tsumikomiYmd) : ''
                return elem
              })
                .sort((a, b) => a.id - b.id) // id昇順にソート
                .forEach((elem) => {
                  const targetIndex = tmpDispJitsuUnsoTaiseiKanriList.findIndex(x => x.id === elem.id)

                  if (targetIndex >= 0) {
                    // 条件1: idが一致 → 上書き
                    tmpDispJitsuUnsoTaiseiKanriList[targetIndex] = elem
                  } else {
                    // 条件2: idが一致しない場合、id <= 0 かつインデックスが最小のものを探す
                    const fallbackIndex = tmpDispJitsuUnsoTaiseiKanriList.findIndex(x => !x.id || x.id <= 0)
                    if (fallbackIndex >= 0) {
                      tmpDispJitsuUnsoTaiseiKanriList[fallbackIndex] = elem
                    }
                  }
                })
              self.rec.jitsuUnsoTaiseiKanriList = Object.assign([], tmpDispJitsuUnsoTaiseiKanriList)
              self.rec.dispJitsuUnsoTaiseiKanriList = Object.assign([], tmpDispJitsuUnsoTaiseiKanriList)
            }
            resolve()
          })
        }
      }
      self.register(opt)
    },
    registerPromise: function () {
      const self = this
      // 変更: del_flgがtrueの場合、editFlgをtrueに設定
      self.rec.jitsuUnsoTaiseiKanriList.forEach(item => {
        if (item.delFlg === true) {
          item.editFlg = true
        }
      })
      self.$refs.ddJitsuUnsoTaiseiKanriboSpread.convertKanriboResult(self.rec)
      self.rec.jitsuUnsoTaiseiKanriList = self.rec.jitsuUnsoTaiseiKanriList.filter((elem) => {
        return elem.editFlg === true
      })
      const f = self.HttpClient.post('/api/v1/TrJitsuUnsoTaiseiKanribo/RangeRegister', self.rec.jitsuUnsoTaiseiKanriList)
      return f
    },
    registerValidate: function () {
      return true
    },
    onExcelButtonClick: function (e) {
      this.$refs.ddJitsuUnsoTaiseiKanriboSpread.onExcelButtonClick()
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        tsumikomiStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        tsumikomiEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        maninushiNm: ''
      }
      this.conditions = initConditions
      this.rec = {
        jitsuUnsoTaiseiKanriList: [],
        dispJitsuUnsoTaiseiKanriList: []
      }
    },
    onClearButtonClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
      })
    },
    // 検索前チェック
    searchValidate: function () {
      return true
    },
    onRowAddClick: function (e) {
      this.$refs.ddJitsuUnsoTaiseiKanriboSpread.rowAppend(e, null)
    },
    onRemoveConditionClick: function (itemNm, type) {
      if (itemNm === 'tsumikomiYmdFromTo') {
        this.conditions.tsumikomiStartYmdString = null
        this.conditions.tsumikomiEndYmdString = null
      } else {
        this.conditions[itemNm] = null
      }
    }
  }
}
